<form novalidate #propertyListingTitleSectionForm="ngForm">
    <tg-input-container
        class="property-listing-title-section__container"
        label="Listing title"
        showRemainingCharacters="false"
    >
        <input
            tgTextInput
            ngModel
            name="listingTitle"
            [validation]="
                validation.propertyDescription.title | toValidator
            "
            placeholder="Make sure this stands out! Buyers see the listing title in search results"
            (blur)="publish()"
            [(ngModel)]="draftData.propertyDescription.title"
        />
    </tg-input-container>
</form>
